import { render, staticRenderFns } from "./batchApproveDialog.vue?vue&type=template&id=f2278444&"
import script from "./batchApproveDialog.vue?vue&type=script&lang=js&"
export * from "./batchApproveDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports